var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel[HeadingLevel["two"] = 2] = "two";
    HeadingLevel[HeadingLevel["three"] = 3] = "three";
    HeadingLevel[HeadingLevel["four"] = 4] = "four";
    HeadingLevel[HeadingLevel["five"] = 5] = "five";
    HeadingLevel[HeadingLevel["six"] = 6] = "six";
})(HeadingLevel || (HeadingLevel = {}));

export { HeadingLevel };
